import React from 'react'
import { Fragment } from 'react'
import { Toast } from './../UI/toast/Toast'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import PageHeader from '../common/PageHeader'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import { useParams } from 'react-router'
import { createDebtReceivable } from '../../helpers/api/finance'
import { useSelector } from 'react-redux'
import CreateDebtReceivableForm from './CreateDebtReceivableForm'
import SupportLink from '../root/support/components/SupportLink'
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreateDebtReceivable = ({ setRedirectUrl, setRedirect }) => {

    const moduleBase = useModuleBase();

    const { id } = useParams();
    const { selectedCondominium } = useSelector(state => state.condominium)

    const create = async values => {
        try {
            const { code } = await createDebtReceivable({
                condominium: id ? id : selectedCondominium,
                ...values
            });
            if (code === SUCCESS_RESPONSE.OK) {
                setRedirectUrl(`/dashboard/${moduleBase}/${id}/receivable`)
                setRedirect(true);
                Toast.fire({
                    type: 'success',
                    title: `Efecto por cobrar registrado exitosamente.`,
                });
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    return  <>
                <PageHeader
                    title="Registrar efecto por cobrar"
                    titleTag="h2"
                    description="Registra un efecto por cobrar y controla la economía del condominio."
                    className="mb-3"
                    col={{ lg: 9 }}
                >
                    <SupportLink/>
                </PageHeader>
                <CreateDebtReceivableForm handleSubmitData={create} />
            </>
}

export default withRedirect(CreateDebtReceivable);